import { render, staticRenderFns } from "./TestBulkAccess.vue?vue&type=template&id=0561c501&scoped=true"
import script from "./TestBulkAccess.vue?vue&type=script&lang=js"
export * from "./TestBulkAccess.vue?vue&type=script&lang=js"
import style0 from "./TestBulkAccess.vue?vue&type=style&index=0&id=0561c501&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0561c501",
  null
  
)

export default component.exports